import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PartnershipListBlock}
 */

const PartnershipList = ({
    title,
    text,
    backgroundColor,
    partners
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <div className={`${bgColor} col-wrapper-breakout rounded-lg flex-grow`}>
            <div className='col-padding py-24'>
                <h2 className='type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-6/12'>
                        {text}
                    </p>
                )}
                <div className='mt-24 sm:grid-cols-2 md:grid-cols-2 gap-y-[9px] sm:gap-y-0 gap-x-16 grid'>
                    {partners.map((partner) => {
                        return (
                            <div
                                className='w-full flex flex-wrap'
                                key={partner.id}>
                                <div className='py-16 border-t border-border-default w-full sm:w-5/6'>
                                    <p className='type-style-sans-h3-med'>
                                        {partner.title}
                                    </p>
                                    {partner.text && (
                                        <p className='type-style-sans-body mt-8'>
                                            {partner.text}
                                        </p>
                                    )}
                                </div>
                                <div className='hidden sm:block w-1/6'/>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PartnershipList;
